/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import queryString from "query-string"
import { useEffect, useRef, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"

import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"

import { RootState } from "../../../globalStore/rootreducer"
import {
  TTorikomiFileGetListReq,
  TTorikomiFileGetListRes,
} from "../../../service/torikomiFiles/TTorikomiFile"
import dateUtil from "../../../ts/util/dateUtil"
import ContentService from "../../../service/content/contentService"
import saveAs from "file-saver"
import MasterRegisterFormRow from "../../../components/MasterRegisterFormRow"
import MonthInput from "../../../components/InputWrapper/MonthInput"
import TextInput from "../../../components/InputWrapper/TextInput"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import MESSAGES from "../../../constant/messages"
import { stringFormat } from "../../../ts/util/commonUtil"
import { showInfoToast } from "../../../components/CustomToast"
import TorikomiFileService from "../../../service/torikomiFiles/TorikomiFileService"
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import ComboBox from "../../../components/ComboBox"
import { 外部ファイル } from "../../../constant/enum/codes"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import KubunService from "../../../service/master/kubun/kubunService"
import { e取込ファイル区分 } from "../../../constant/enum/gaibuFile"

//#region [types]

export type TDataGridItem = TTorikomiFileGetListRes

//#endregion

/**
 * 給油量データ取込
 * @returns
 */
const KyuyuryoDataTorikomi = () => {
  const history = useHistory()
  const location = useLocation()
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)
  const 給油取込区分リスト: string[] = [
    e取込ファイル区分.宇佐美_給油CSV,
    e取込ファイル区分.ENEOS_給油CSV,
    e取込ファイル区分.自社_給油CSV,
    e取込ファイル区分.自社_給油CSV_2025,
  ]

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "KyuyuryoDataTorikomi_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TTorikomiFileGetListRes>,
    pageSize: number
  ) => {
    return new wjCore.CollectionView<TDataGridItem>(data, {
      pageSize,

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TTorikomiFileGetListReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に
    let currentSearchCondition: TTorikomiFileGetListReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    setPrevSearchCondition(currentSearchCondition)

    try {
      const res = await new TorikomiFileService().getList({
        ...currentSearchCondition,
      })
      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    const errorList: string[] = []
    if ((取込データ年月 ?? "") === "")
      errorList.push(stringFormat(MESSAGES.WARNS.W001, "取込データ年月"))
    if (取込ファイル == null)
      errorList.push(stringFormat(MESSAGES.WARNS.W010, "取込ファイル"))
    if (取込ファイル区分コード == null || 取込ファイル区分コード === "")
      errorList.push(stringFormat(MESSAGES.WARNS.W010, "取込ファイル区分"))

    if (0 < errorList.length) {
      dispatch(setWarningAlerts(errorList))
      return
    }

    dispatch(clearAlert())
    setIsConfirmModalShow(true)
  }

  /**
   * 送信
   */
  const submit = async () => {
    try {
      const service = new TorikomiFileService()
      await service.post({
        取込データ年月: 取込データ年月,
        取込ファイル: 取込ファイル!,
        取込ファイル区分コード: 取込ファイル区分コード!,
        備考: 備考 ?? "",
      })

      showInfoToast(`ファイル取込が完了しました`)
      clearInputState()
      search(prevSearchCondition)
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  const fileUpload: React.MouseEventHandler<HTMLElement> = (e) => {
    e.stopPropagation()
    e.preventDefault()
    if (refFileInput && refFileInput.current) {
      refFileInput.current.click()
    }
  }

  const onFileInputChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    if (e.target.files != null && e.target.files[0]) {
      set取込ファイル(e.target.files[0])
      set取込ファイル名(e.target.files[0].name)
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = (): TTorikomiFileGetListReq => {
    const query = queryString.parse(location.search) as TTorikomiFileGetListReq
    set取込データ年月(query.取込データ年月)
    set取込ファイル区分コード(query.取込ファイル区分コード ?? "")
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TTorikomiFileGetListReq => {
    return {
      取込データ年月: 取込データ年月 ?? "",
      取込ファイル区分コード: 取込ファイル区分コード ?? "",
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TTorikomiFileGetListReq
  ) => {
    return {
      取込データ年月: dateUtil.format(
        searchCondition.取込データ年月,
        "YYYY/MM"
      ),
      取込データファイル区分: 区分ItemSource?.find(
        (i) =>
          i.区分コード === searchCondition.取込ファイル区分コード &&
          i.分類コード === 外部ファイル.取込ファイル区分
      )?.名称1,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    // 前回検索条件をクリア
    setPrevSearchCondition(undefined)

    clearSearchState()

    // 登録情報もクリア
    clearInputState()

    // querystringをクリア
    pageHelper.clearQuery(history, location)
    // AlertClear
    dispatch(clearAlert())
  }

  const clearSearchState = () => {
    set取込データ年月(eigyobi)
    // 先頭を設定
    set取込ファイル区分コード(給油取込区分リスト[0])
  }

  const clearInputState = () => {
    if (refFileInput.current) {
      refFileInput.current.value = ""
    }
    set取込ファイル(undefined)
    set取込ファイル名("")
    set備考("")
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)
    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    // 固定行ヘッダの設定
    for (let r = 0; r < f.rows.length; r++) {
      f.rowHeaders.setCellData(r, 0, r + 1)
    }

    if (e.panel === f.cells) {
      // const cellBinding = e.getColumn().binding
      // const rowData: TDataGridItem = e.getRow().dataItem
      // if (!rowData) return
    }
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  //grid内エラー項目格納Array
  // const [errorCellPositionList] = useState<
  //   Array<{ 行ID: symbol; colBinding: string }>
  // >([])

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)
  const [accordionController2, setAccordionController2] =
    useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  // ComboBox制御
  const [comboDataInitialized, setComboDataInitialized] =
    useState<boolean>(false)

  //#endregion

  //#region [state]

  const [取込データ年月, set取込データ年月] = useState<string>(eigyobi)
  const [取込ファイル区分コード, set取込ファイル区分コード] = useState<
    string | null
  >(null)
  const [取込ファイル, set取込ファイル] = useState<File>()
  const [取込ファイル名, set取込ファイル名] = useState<string>("")
  const [備考, set備考] = useState<string>("")
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()

  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  const [prevSearchCondition, setPrevSearchCondition] =
    useState<TTorikomiFileGetListReq>()

  // [comboboxState]

  const [取込ファイル区分ComboBox, set取込ファイル区分ComboBox] =
    useState<TWijmoComboBox<string, T区分マスタ> | null>(null)
  const [取込ファイル区分IsLoadEnded, set取込ファイル区分IsLoadEnded] =
    useState<boolean>(false)

  //#endregion

  // #region [refs]

  // ファイルアップデート用
  const refFileInput = useRef<HTMLInputElement>(null)

  //#endregion

  //#region [effect]

  useEffect(() => {
    document.title = `給油量データ取込`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())

    new KubunService()
      .getList()
      .then((区分マスタRes) => set区分ItemSource(区分マスタRes.data))
  }, [])

  useEffect(() => {
    if (!取込ファイル区分IsLoadEnded) return

    setComboDataInitialized(true)
  }, [取込ファイル区分IsLoadEnded])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && comboDataInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized, comboDataInitialized])

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">給油量データ取込</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* ==================== 検索条件カード ==================== */}
          <Card className="w-50rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div className="w-10rem">
                              <MonthInput
                                autoFocus={true}
                                id="取込データ年月"
                                isRequired
                                value={取込データ年月}
                                setValue={(v) => set取込データ年月(v!)}
                                placeholder="取込データ年月"
                              />
                            </div>
                            <div className="w-25rem">
                              <ComboBox.Kubun
                                placeholder="取込ファイル区分"
                                分類コード={外部ファイル.取込ファイル区分}
                                listFilter={(item) =>
                                  給油取込区分リスト.includes(item.区分コード)
                                }
                                isRequired={true}
                                isAllSelect={false}
                                itemsSource={区分ItemSource}
                                selectedValue={取込ファイル区分コード}
                                setSelectedValue={set取込ファイル区分コード}
                                isLoadEnded={取込ファイル区分IsLoadEnded}
                                setIsLoadEnded={set取込ファイル区分IsLoadEnded}
                                ComboBox={取込ファイル区分ComboBox}
                                setComboBox={
                                  set取込ファイル区分ComboBox
                                }></ComboBox.Kubun>
                            </div>
                            <Button
                              type="submit"
                              className="ms-auto"
                              disabled={isSearching}
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                search()
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                              検索
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* ==================== 登録情報カード ==================== */}
          <Card className="w-75rem">
            <Card.Header
              onClick={() => setAccordionController2(!accordionController2)}
              aria-controls="collapse-card-body"
              aria-expanded={accordionController2}>
              <FontAwesomeIcon
                icon={accordionController2 ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              登録情報
            </Card.Header>
            <Collapse in={accordionController2}>
              <Card.Body>
                <Container fluid className="register-form">
                  <MasterRegisterFormRow
                    label="取込データ年月"
                    isRequired={true}
                    isRemarks={false}>
                    <label>
                      {prevSearchCondition &&
                        dateUtil.format(
                          prevSearchCondition.取込データ年月,
                          "YYYY/MM"
                        )}
                    </label>
                  </MasterRegisterFormRow>
                  <MasterRegisterFormRow
                    label="取込ファイル区分"
                    isRequired={true}
                    isRemarks={false}>
                    <label>
                      {prevSearchCondition?.取込ファイル区分コード &&
                        区分ItemSource?.find(
                          (i) =>
                            i.区分コード ===
                              prevSearchCondition.取込ファイル区分コード &&
                            i.分類コード === 外部ファイル.取込ファイル区分
                        )?.名称1}
                    </label>
                  </MasterRegisterFormRow>
                  <MasterRegisterFormRow
                    label="取込CSV選択"
                    isRequired={true}
                    isRemarks={false}
                    Width={55}>
                    {取込ファイル名}
                    <Button
                      disabled={prevSearchCondition == null}
                      type="submit"
                      className="btn btn-small btn-upload ms-2"
                      variant="done"
                      onClick={fileUpload}>
                      ファイル選択
                    </Button>
                    <input
                      type="file"
                      hidden
                      accept=".csv"
                      ref={refFileInput}
                      onChange={onFileInputChange}
                    />
                  </MasterRegisterFormRow>
                  <MasterRegisterFormRow
                    label="備考"
                    isRequired={false}
                    isRemarks={false}>
                    <TextInput
                      isReadOnly={prevSearchCondition == null}
                      className="w-35rem"
                      id="備考"
                      name="備考"
                      value={備考}
                      setValue={set備考}
                    />
                  </MasterRegisterFormRow>
                  <br />
                  <Row className="search-button">
                    <Col xl={{ span: "auto", offset: 0 }}>
                      <Button
                        disabled={prevSearchCondition == null}
                        variant="waiting"
                        type="submit"
                        onClick={(e) => {
                          e.stopPropagation()
                          e.preventDefault()
                          beforeSubmit()
                        }}>
                        {`登録`}
                      </Button>
                    </Col>
                  </Row>
                </Container>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={`${gridId}_1`}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                isShowGridRowPickupButton={false}
                gridProperties={{
                  allowAddNew: false,
                }}
                headerComponent={<></>}>
                <wjrGrid.FlexGridColumn
                  binding="作成日時"
                  width={150}
                  header="実行日時">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TDataGridItem>
                    ) => {
                      return (
                        <>
                          {dateUtil.format(
                            context.item.作成日時,
                            "YYYY/MM/DD HH:mm"
                          )}
                        </>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="ファイル名"
                  width={500}
                  header="ファイル名">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TDataGridItem>
                    ) => {
                      if ((context.item.ファイルURL ?? "") === "")
                        return context.item.ファイル名
                      return (
                        <a
                          href={context.item.ファイルURL}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => {
                            e.preventDefault()
                            const service = new ContentService()
                            service
                              .get(context.item.ファイルURL!)
                              .then((blob) => {
                                saveAs(blob, context.item.ファイル名)
                              })
                              .catch((err) => dispatch(setAlerts(err)))
                          }}>
                          {context.item.ファイル名}
                        </a>
                      )
                    }}></wjrGrid.FlexGridCellTemplate>
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="取込データ年月"
                  width={150}
                  header="取込データ年月">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TDataGridItem>
                    ) => {
                      return (
                        <>
                          {dateUtil.format(
                            context.item.取込データ年月,
                            "YYYY/MM"
                          )}
                        </>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="備考"
                  width={400}
                  header="備考"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で登録しますか？
      </ConfirmModal>
    </Container>
  )
}

export default KyuyuryoDataTorikomi
